import React, { useEffect, useState, useRef } from 'react'
import { Modal, Row, Typography, Card, Col, Form, Space, Button, Input } from 'antd'
import { EmailGlobalHeader, GlobalFooter, EmptyHeaderHero } from './components'
import { useRouter } from 'next/router'
import { getPolicyFromEmailUpdateToken } from '../services/Api'
import { useSearchParams } from 'next/navigation'

const { Title, Text } = Typography

const EmailUpdate = () => {
    const searchParams = useSearchParams()
    const [policyNumber, setPolicyNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [confirmEmailAddress, setConfirmEmailAddress] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(true)

    useEffect(() => {
        async function go() {
            const a = searchParams.get('tkn')
            console.log(a)
            if (!!searchParams.get('tkn')) {
                const tokenObj = { Token: searchParams.get('tkn') }
                const getPolicyFromEmailUpdateTokenResponse = await getPolicyFromEmailUpdateToken(tokenObj)
                setPolicyNumber(getPolicyFromEmailUpdateTokenResponse.PolicyNumber)
            }
        }
        go();
    }, [searchParams])

    const handleSubmit = async () => {
        const validEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)
        setErrorMessage("")
        if (emailAddress !== confirmEmailAddress) {
            setErrorMessage("Both email fields must match.")
        }
        else if (!validEmail.test(emailAddress)) {
            setErrorMessage("Please enter a valid email address above.")
        }
        else {
            const newWindow = window.open(`/email-update-result?emailAddress=${emailAddress}&policyNumber=${policyNumber}`, '_self', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
    }

    const anyFieldsBlank = async () => {
        if (emailAddress === "" || confirmEmailAddress === "") {
            setSubmitDisabled(true)
            return true
        }
        else {
            setSubmitDisabled(false)
            return false
        }
    }

    return (
        <>
            <EmptyHeaderHero
                minHeight={true}
                title='Update Your Email'
            />
            <div className="email-update vh-71">
                <Row>
                    <Card bordered={false} className="register-card">
                        <p style={{paddingBottom: "0px", marginBottom: "0px", fontSize: "18px", color: "#2a5a9b"}}>Please confirm your policy information and enter your email address below.</p>
                        <Row style={{paddingTop: "20px"}}>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="margin-bottom-14" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                    <Input
                                        className="input-text phone-number"
                                        onChange={event => {
                                            setEmailAddress(event.target.value)
                                        }}
                                        onBlur={() => (anyFieldsBlank())}
                                        placeholder="Email Address*"
                                        value={emailAddress}
                                    />
                                    <Input
                                        className="input-text phone-number"
                                        onChange={event => {
                                            setConfirmEmailAddress(event.target.value)
                                        }}
                                        onBlur={() => (anyFieldsBlank())}
                                        placeholder="Confirm Email Address*"
                                        value={confirmEmailAddress}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Text style={{ color: "red", fontSize: "16px" }}>{errorMessage}</Text>
                        </Row>
                        <Row style={{paddingTop: "20px"}}>
                            <Form.Item className="btn-control button-submit-form">
                                <Space>
                                    <Button className="register register-form-button" style={{ width: "175px", borderRadius: "12px", background: "#ff8000", color: "white" }} disabled={submitDisabled} onClick={() => handleSubmit()}>
                                        Update
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Row>
                    </Card>
                </Row>
            </div>
        </>
    )
}

EmailUpdate.propTypes = {}

export default EmailUpdate
